export const scrollBottom = () => window.scrollTo(0, document.body.scrollHeight);
export const scrollTop = () => window.scrollTo(0, 0);
export const preventScroll = () => document.body.classList.add('no-scroll');
export const enableScroll = () => {
  if (document.body.classList.contains('no-scroll')) {
    document.body.classList.remove('no-scroll');
  }
};
